"use strict";

import PackageRoutes from "./package.routes";
import PackageVersionRoutes from "./package_version.routes";
import PackageOrganizationRoutes from "./package.organization.routes";
import PackageVersionOrganizationRoutes from "./package_version.organization.routes";

export default {
  PackageRoutes, PackageVersionRoutes, PackageOrganizationRoutes, PackageVersionOrganizationRoutes
};
